export default "__VITE_ASSET__078d867b__"